const voucher = voucher => (voucher ? voucher.replace(/ - /g, '') : '');

const date = date =>
  date
    ? date
        .split('/')
        .reverse()
        .join('')
    : '';

export default {
  voucher,
  date
};
